import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Loader from "./components/pages/Loader";

function AppWrapper({ children }) {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [loaderEnabled, setLoaderEnabled] = useState(false);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await fetch("/webcontrollerdata.json");
        const data = await res.json();
        setLoaderEnabled(data.loaderEnabled);
      } catch (err) {
        console.error("Error loading JSON config:", err);
      }
    };
    fetchConfig();
  }, []);

  useEffect(() => {
    if (!loaderEnabled) return; 

    setLoading(true);
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 1000); 
    return () => clearTimeout(timeout);
  }, [location.pathname, loaderEnabled]);

  return (
    <>
      {loading && loaderEnabled && <Loader />}
      {children}
    </>
  );
}

export default AppWrapper;
